"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlChartFactory = void 0;
const chart_component_1 = require("./chart-component");
const event_service_1 = require("../eventing/event-service");
const graph_attach_point_1 = require("../templating/graph-attach-point");
const graph_attach_point_provider_1 = require("../templating/graph-attach-point-provider");
const chart_config_1 = require("./chart-config");
const gl_renderer_1 = require("../rendering/gl/gl-renderer");
/**
 * @public
 * Factory to make {@link TGlChart}.
 */
class GlChartFactory {
    static createOne(options) {
        const eventService = new event_service_1.EventService();
        const attachPoint = new graph_attach_point_1.GraphAttachPoint(new graph_attach_point_provider_1.GraphAttachPointProvider(options.chartContainer), eventService, options.chartConfig);
        const contextAdapter = new options.contextAdapterCtor(attachPoint.canvasElement, eventService, options.rendererOptions.onCreate.contextAttributes);
        const config = new chart_config_1.ChartConfig();
        const renderer = gl_renderer_1.GlRenderer.createOne(contextAdapter.getContext(), options.rendererOptions);
        if (renderer == null) {
            return null;
        }
        return new chart_component_1.ChartComponent(attachPoint, renderer, eventService, config, contextAdapter);
    }
}
exports.GlChartFactory = GlChartFactory;
//# sourceMappingURL=gl-chart-factory.js.map